<template>
  <div>
    <footer class="bg-primary text-center text-white" style="height: 4.375rem;background: linear-gradient(90deg, rgba(6,2,74,1) 0%, rgba(21,15,129,1) 47%);">
      <p style="line-height: 4.375rem;">Hak Cipta 2023 | Dinas Pendidikan Labuhanbatu</p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'AuthFooter'
}
</script>

<style>

</style>